import React from "react";
import { TextArea } from "@yoti/ui-kit-components-react/text-area";
import styles from "./SelectDevices.module.scss";
import { Panel } from "../../Panel/Panel";

const Description = ({ value, onChange }) => (
  <div className={styles.root}>
    <Panel>
      <div className={styles.text}>
        <h3>Description</h3>
      </div>
    <TextArea
      placeholder="OS - Browser - Any used tools"
      label="Description"
      value={value}
      onChange={onChange}
    />
    <br />
    </Panel>
  </div>
)

export default Description;
